// TODO: get rid of string based paths
var getInPath = function getInPath(data, pathStr) {
  var path = pathStr.split('.');
  var value = data;
  path.forEach(function (key) {
    if (value) {
      value = value[key];
    }
  });
  return value;
};

export { getInPath };
